import { Component, Input, OnInit, EventEmitter, Output, ViewChild, Renderer2, ElementRef } from '@angular/core';
import { constants } from '../../utitlity/constant';
import { QuestionBase } from './../question-base';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ControlContainer, NgForm } from '@angular/forms';
import { LeadFormService } from '../../services/lead-form.service';

@Component({
    selector: "aed-input-field",
    template: require('./aed-input-field.component.html'),
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class AEDInputFieldComponent implements OnInit {
    @Input() question: QuestionBase<any>;
    @Input() questions: any = [];
    @Input() form: NgForm;
    inputModel: any;
    inputName: string;
    @Output() onNumberChange: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('fieldValue') fieldValueRef;
    @ViewChild('fieldValueElementRef') fieldValueElementRef;
    isLeadFormApplication: boolean;
    isIncomeValid: boolean;
    minMonthlyIncomeValidationMsg: string;

    constructor(private renderer: Renderer2,
                private leadFormService: LeadFormService) { }

    ngOnInit() {
        this.inputName = this.question.backendField+'1';
        this.inputModel = this.question.value;

        this.isLeadFormApplication = constants.IS_LEAD_FORM_APPLICATION;
        this.isIncomeValid = true;
        this.minMonthlyIncomeValidationMsg = "";
    }
    checkInput(question) {
        this.question.value = this.inputModel;

        if(this.isLeadFormApplication && this.question.backendField == 'monthlyIncome') {
            // Check for Income validity based on product
            this.isIncomeValid = this.checkIfIncomeIsValid();

            if(this.fieldValueRef.touched) {
                if(this.isIncomeValid) {
                    this.renderer.removeClass(this.fieldValueElementRef.nativeElement, 'invalid-text-border');
                } else {
                    this.renderer.addClass(this.fieldValueElementRef.nativeElement, 'invalid-text-border');
                }
            }
            
        }

        //let invalidChars = /(^\s+|\s+$)/g;
        let invalidChars = /[^0-9]/gi;
        // if (invalidChars.test(question.value) || parseInt(question.value) == 0) {
        //     if (parseInt(question.value) == 0) {
        //         question.value = "";
        //     }
        //     else {
        //         question.value = question.value.replace(invalidChars, "");
        //         if (parseInt(question.value) == 0) {
        //             question.value = "";
        //         }
        //     }
        // }
        // else {

        // }
        if (invalidChars.test(this.inputModel) || parseInt(this.inputModel) == 0) {
            if (parseInt(this.inputModel) == 0) {
                this.inputModel = "";
            }
            else {
                this.inputModel = this.inputModel.replace(invalidChars, "");
                if (parseInt(this.inputModel) == 0) {
                    this.inputModel = "";
                }
            }
        }
        else if((this.inputModel+'').match(/^0/)) {
            this.inputModel = (this.inputModel+'').replace(/^0+/g, '');
        }
    }
    onNumberFieldChange(question, form) {
        this.checkInput(question);
        this.question.value = this.inputModel;
        this.onNumberChange.emit({
            question: question,
            questions: this.questions,
            form: this.form,
            type: 'numberChange',
        });
        
        this.addCommas(question);
    }

    removeCommas(question) {
        this.inputModel = this.inputModel.replace('AED ', '').replace(',', '').replace(',', '');
        question.maxFieldLength = 6;
    }

    addCommas(question) {
        if (this.inputModel) {
            this.inputModel = this.inputModel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            this.inputModel = "AED " + this.inputModel;
            question.maxFieldLength = 11;
        }
    }
    checkIfIncomeIsValid() {
        let isValid = true;
        let productDetails = this.leadFormService.getLeadProductDetails()["productDetails"];
        let minMonthlyIncome = parseInt(productDetails["minimumMonthlyIncome"]);

        if(this.inputModel < minMonthlyIncome) {
            isValid = false;
            this.minMonthlyIncomeValidationMsg = `Minimum Monthly Income required is AED ${minMonthlyIncome}`;
        }
        return isValid;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/components/aed-input-field/aed-input-field.component.ts